import { render } from "./DetallesPisto.vue?vue&type=template&id=77db885b"
import script from "./DetallesPisto.vue?vue&type=script&lang=js"
export * from "./DetallesPisto.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Github\\Vue\\drinks\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__